import { schema } from 'normalizr';


const attachment = new schema.Entity(
  'attachments',
  {},
  { idAttribute: '_id' },
);

const contactSingle = new schema.Entity(
  'contacts',
  {},
  { idAttribute: '_id' },
);

const logSingle = new schema.Entity(
  'logs',
  {},
  { idAttribute: '_id' },
);

const meetingNoteSingle = new schema.Entity(
  'meetingNotes',
  {
    participants: {
      contacts: [contactSingle],
    },
  },
  { idAttribute: '_id' },
);

const commentSingle = new schema.Entity(
  'comments',
  {},
  { idAttribute: '_id' },
);

const taskSingle = new schema.Entity(
  'tasks',
  {},
  { idAttribute: '_id' },
);

const userSingle = new schema.Entity(
  'users',
  {},
  { idAttribute: '_id' },
);

export const request = new schema.Entity(
  'requests',
  {
    contacts: [contactSingle],
    meetingNotes: [meetingNoteSingle],
    comments: [commentSingle],
    tasks: [taskSingle],
    logs: [logSingle],
    attachments: [attachment],
  },
  { idAttribute: '_id' },
);

const contact = new schema.Entity(
  'contacts',
  {
    requests: [request],
  },
  { idAttribute: '_id' },
);

export const meetingNote = new schema.Entity(
  'meetingNotes',
  {
    request,
    meetingTasks: [taskSingle],
    participants: {
      users: [userSingle],
      contacts: [contact],
    },
    createdBy: userSingle,
  },
  { idAttribute: '_id' },
);

const log = new schema.Entity(
  'logs',
  {
    request,
    createdBy: userSingle,
  },
  { idAttribute: '_id' },
);

const comment = new schema.Entity(
  'comments',
  {
    request,
    createdBy: userSingle,
  },
  { idAttribute: '_id' },
);

export const task = new schema.Entity(
  'tasks',
  {
    request,
    createdBy: userSingle,
  },
  { idAttribute: '_id' },
);

export const contacts = {
  contacts: [contact],
};

export const company = new schema.Entity(
  'companies',
  {
    requests: [request],
    contacts: [contact],
    comments: [comment],
    attachments: [attachment],
  },
  { idAttribute: '_id' },
);

export const companies = {
  companies: [company],
};

export const requests = {
  requests: [request],
};

export const meetingNotes = {
  meetingNotes: [meetingNote],
};

export const logs = {
  logs: [log],
};

export const comments = {
  comments: [comment],
};

export const tasks = {
  tasks: [task],
};




// WEBPACK FOOTER //
// ./src/api/schemes.js